import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-brand-line bg-brand-light px-4 py-4" data-id="element-157" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-4xl" data-id="element-158" data-mp="3fym86mxaf65e">
        <div className="mb-2 text-center" data-id="element-159" data-mp="3fxb38js3vscp">
          <h2 className="mb-0 font-display text-2xl uppercase leading-none tracking-wide sm:text-4xl" data-id="element-160" data-mp="3b1cjxalmx0j5">
            What Coaches Are Saying
          </h2>
          <p className="font-head text-[11px] font-semibold uppercase tracking-wide text-brand-blue sm:text-sm" data-id="element-161" data-mp="36wmofmuw1nyr">
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews
          </p>
        </div>
        <div className="grid gap-2 sm:grid-cols-2" data-id="element-162" data-mp="2x2w48u5snzov">
          {testimonials.map(testimonial => <article key={testimonial.author} className="flex flex-col rounded-lg border border-brand-line bg-white p-3 shadow-sm" data-id="element-163" data-mp="2s3tba8339jx9">
              <div className="mb-1 flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-164" data-mp="qavb1r6zfp2a">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-165" data-mp="h8awv9l20jp4" />)}
              </div>
              <p className="mb-2 text-xs font-medium italic leading-snug text-brand-muted sm:text-sm" data-id="element-166" data-mp="c6bua1x51qt8">
                “{testimonial.text}”
              </p>
              <div className="mt-auto flex items-center gap-2.5 border-t border-brand-line pt-2" data-id="element-167" data-mp="zyiuxd9wcjyg">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-navy font-head text-sm font-bold text-brand-gold" data-id="element-168" data-mp="14xlp22oc95rn">
                  {testimonial.author.charAt(0)}
                </span>
                <div className="leading-tight" data-id="element-169" data-mp="1ivk294qxaw5k">
                  <p className="font-head text-[13px] font-bold text-brand-navy" data-id="element-170" data-mp="1itqxjuzvem07">
                    {testimonial.author}
                  </p>
                  <p className="text-[10px] font-semibold uppercase tracking-wide text-brand-muted sm:text-[11px]" data-id="element-171" data-mp="1xhqwxlkg5msf">
                    {testimonial.role} — {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}